<!--
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Date: 2022-06-30 11:35:50
 * @Description: 页脚工具栏
-->
<template>
  <div class="uk-section uk-section-small uk-section-muted no-print ndq-tools">
    <div class="uk-container uk-text-center">
      <div class="uk-grid-match uk-flex-center uk-child-width-1-4@m" uk-grid>
        <div class="uk-visible@m">
          <div ref="printRef" class="tools-inner"  @click="printPage">
            <button class="uk-button uk-button-link tools-icon">
              <span uk-icon="icon: print; ratio: 1.5"></span>
            </button >
            <div class="tools-name">{{$t('layout.footerBar.print')}}</div>
          </div>
        </div>
        <div>
          <div class="tools-inner" @click="() => $router.push({name: 'about-irNetwork'})">
            <button class="uk-button uk-button-link tools-icon">
              <span uk-icon="icon: receiver; ratio: 1.5"></span>
            </button >
            <div class="tools-name">{{$t('layout.footerBar.contact')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import rentGo_commonBiz from "@/tools/rentGo/commons/index.js";

export default {
  name: "FooterTools",

  methods: {
    printPage() {
      console.log("🚀 ~ file: footer-tools.vue ~ line 37 ~ printPage ~ printPage")
      window.print()
      
      // 埋点上报
      // rentGo_commonBiz.printPage();
    }
  }
};
</script>

<style lang="less" scoped>
.tools-icon {
  border: 1px solid #666666;
  border-radius: 100%;
  width: 75px;
  height: 75px;
  line-height: 75px;
  text-align: center;
  margin: auto;
}
.ndq-tools{
    padding: 30px 0 40px 0;
    background: #f5f5f5;
    height: auto;
    margin: 0 auto;
    text-align: center;
}
.tools-name{
    margin-top: 20px;
    font-size: 14px;
}
</style>
